import { render, staticRenderFns } from "./WordpressThreat.vue?vue&type=template&id=9351a07e&scoped=true&"
import script from "./WordpressThreat.vue?vue&type=script&lang=js&"
export * from "./WordpressThreat.vue?vue&type=script&lang=js&"
import style0 from "./WordpressThreat.vue?vue&type=style&index=0&id=9351a07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9351a07e",
  null
  
)

export default component.exports